<template>
    <div>
        <div class="page-wrapper compact-wrapper" id="pageWrapper">

            <div class="container-fluid p-0">
                <div class="comingsoon">
                    <div class="comingsoon-inner text-center">
                        <div class="logo-wrraper"><img class="img-fluid" src="@/assets/images/logo/logo.png" alt="logo">
                        </div>
                        <h5>Let's Get Started With <br>KOHO</h5>
                        <div class="svg-wrapper"><img class="img-fluid comingsoon-img"
                                src="@/assets/images/other-images/comingsoon-img.svg" alt="comingsoon-img"></div>
                        <h6>We Are Coming Soon</h6>
                        <div class="countdown" id="clockdiv">
                            <Timer />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import Timer from './comingsoon_timer';

export default {
    components: {
        Timer
    },
    data() {
        return {
            startTime: 'Apr 29, 2021 00:00:00',
            endTime: 'Apr 29, 2022 00:00:00',
        };
    },
};
</script>
